import { createFileRoute, redirect } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute("/duo/")({
  beforeLoad: () => {
    checkPermissions("read", "duo")
    throw redirect({ to: "/duo/contractenlijsten", replace: true })
  },
})
